<template>
  <div class="target-value-input">
    <div class="tooltip-precision" v-if="showPrecisionTooltip">
      <div class="tooltip-precision__label">Too high precision</div>
      <tooltip class="tooltip-precision__message" left orange>
        For {{tickerName}} {{valueTypeName}} {{alertType.value.toLowerCase()}},
        the maximum precision is {{availablePrecision}} decimal points. Your value will be rounded up.
      </tooltip>
    </div>
    <div class="target-value-input__wrapper">
      <input-el
        type="text"
        placeholder="Enter value"
        label="Change value"
        inputId="targetDelta"
        class="target-value"
        name="targetDelta"
        v-model="currentValue"
        :error="error"
        errorTop
        maxlength="20"
        :class="{'target-value_orange-border': showPrecisionTooltip}"
      />
      <div
        @click="$emit('toggleDirection')"
        title="Switch alert direction"
        class="dirrection-switcher"
      >
        <icon-tendency-arrow
          class="dirrection-switcher__icon"
          :up="directionIsUp"
        />
        <span
          class="dirrection-switcher__text"
          :class="{'dirrection-switcher__text_green': directionIsUp}"
        >{{ directionIsUp ? 'increase' : 'decrease' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { IconTendencyArrow } from 'Icons';
import { upDirection } from 'src/models/AlertsConditionTypes';

export default {
  components: {
    IconTendencyArrow,
  },
  props: {
    showPrecisionTooltip: Boolean,
    availablePrecision: Number,
    valueTypeName: String,
    alertType: {
      type: Object,
      required: true,
    },
    tickerName: String,
    value: String,
    error: Boolean,
    increase: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    directionIsUp() {
      return this.alertType.direction === upDirection;
    },
    currentValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-precision {
  position: absolute !important;
  top: -2px;
  right: 0;
  z-index: 1;
  &__label {
    @include font(12px, $grey-color2, 500);
    margin-right: 21px;
    margin-top: 1px;
  }
  &__message {
    position: absolute !important;
    right: 0;
    top: 0;
  }
}
.target-value-input {
  width: 300px;
  &__wrapper {
    position: relative;
  }
}
.dirrection-switcher {
  user-select: none;
  position: absolute;
  right: 11px;
  bottom: 10px;
  height: 30px;
  width: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &__icon {
    margin-right: 4px;
  }
  &__text {
    font-size: 9px;
    color: $red-color3;
    &_green {
      color: $green-color1;
    }
  }
}
@media screen and (max-width: 376px) {
  .target-value-input__wrapper {
    width: 267px;
    margin-left: -$side-margin;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/alertCreation/TargetValueInput.vue